import {weChatrequest} from '@/utils/request'

// 查询字典类型列表
export function listType(query) {
  return weChatrequest({
    url: '/api/v1/dict/page',
    method: 'get',
    params: query
  })
}

// 查询字典类型详细
export function getType(dictId) {
  return weChatrequest({
    url: '/system/dict/type/' + dictId,
    method: 'get'
  })
}

// 新增字典类型
export function addType(data) {
  return weChatrequest({
    url: '/api/v1/dict',
    method: 'post',
    data: data
  })
}

// 修改字典类型
export function updateType(data) {
  return weChatrequest({
    url: `/api/v1/dict/${data.id}`,
    method: 'PUT',
    data
  })
}

// 删除字典类型
export function delType(dictId) {
  return weChatrequest({
    url: 'api/v1/dict/' + dictId,
    method: 'DELETE'
  })
}

// 导出字典类型
export function exportType(query) {
  return weChatrequest({
    url: '/system/dict/type/export',
    method: 'get',
    params: query
  })
}

// 获取字典选择框列表
export function optionselect() {
  return weChatrequest({
    url: '/system/dict/type/optionselect',
    method: 'get'
  })
}